import product from './product';
import review from './review';

export const schemaTypes = [product, review];
